// Textos de la home en español. En los textos "rich" la etiqueta <b> se muestra en negrita, <link> como enlace.
const home = {
  nav: {
    home: "Inicio",
    services: "Servicios",
    qa: "Quality Assurance",
    products: "Productos",
    references: "Referencias",
    about: "Quiénes somos",
    workWithUs: "Trabaja con nosotros",
    contact: "Contáctanos",
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    menu: "Menú",
  },

  hero: {
    text: "Una software house potenciada por la IA y gobernada por la Quality Assurance. Construimos entregas más rápidas, controladas y escalables.",
    ctaServices: "Descubre los servicios",
    ctaTalk: "Habla con nosotros",
  },

  partners: {
    label: "HAN ELEGIDO QAPEX",
    aria: "Partners",
  },

  model: {
    eyebrow: "Nuestro modelo",
    title: "No solo desarrollo de software.",
    lead: "La IA aumenta la velocidad. La ventaja competitiva nace cuando esa velocidad sigue <b>gobernada</b>. Unimos pipelines de IA, desarrollo y Quality Assurance en un único flujo operativo.",
    agentic: {
      title: "AGENTIC ENGINEERING",
      text: "Pipelines de IA y automatización que aceleran análisis, desarrollo y documentación en proyectos de cualquier tamaño, también en la nube.",
    },
    qa: {
      title: "QUALITY ASSURANCE",
      text: "QA estructurada e integrada en cada fase: control, método y fiabilidad del proceso y del producto. La IA no sustituye a la ingeniería: la amplifica.",
    },
  },

  services: {
    eyebrow: "Nuestros servicios",
    title: "Servicios modulares, calidad integrada.",
    lead: "Para acelerar roadmaps digitales, automatizaciones y aplicaciones cloud-native.",
    items: [
      { title: "DevOps en la nube", text: "Pipelines CI/CD, infraestructura como código y entornos cloud escalables, monitorizados y seguros." },
      { title: "Pipelines de IA para empresas", text: "Automatizaciones inteligentes que aceleran análisis, documentación y procesos empresariales." },
      { title: "IA local y modelos a medida", text: "Modelos de IA privados u on-premise, entrenados con tus datos sin exponerlos al exterior." },
      { title: "Web y móvil cloud-native", text: "Sitios, e-commerce y apps diseñados para escalar: rápidos, usables y orientados a la conversión." },
      { title: "Optimización y rendimiento", text: "Análisis, pruebas de carga y ajuste para aplicaciones más rápidas, estables y fiables." },
      { title: "AI Code Assurance", text: "Verificamos el código generado por la IA: revisión, pruebas y gobernanza antes de cada lanzamiento." },
    ],
  },

  qa: {
    eyebrow: "Quality Assurance · Nacidos para la automatización de pruebas",
    title: "Quality is",
    titleHighlight: "not accidental.",
    lead: "La QA no frena la entrega: la hace sostenible. Equipos certificados ISTQB, IA propia y automatización en cada ciclo de lanzamiento.",
    cards: [
      {
        tag: "END-TO-END",
        title: "QA Service Provider",
        text: "El núcleo de nuestra oferta: gestión end-to-end y escalable de las pruebas. Testbooks a medida con IA propia, ciclos de pruebas funcionales, de sistema y de integración, regresiones trazadas en cada push.",
        chips: ["Gestión end-to-end", "Escalabilidad garantizada", "Calidad continua"],
      },
      {
        tag: "PREMIUM",
        title: "QA Consulting",
        text: "Consultores con experiencia corporativa y competencias transversales: \"dualistas\" que dominan pruebas manuales y automatización, con la IA integrada en su trabajo diario.",
        chips: ["Experiencia certificada", "Adaptabilidad inmediata", "Competencia híbrida"],
      },
    ],
    cert: {
      eyebrow: "Certificación Qapex",
      title: "Prueba con Qapex.",
      titleLine2: "Lanza con nuestro certificado.",
      discover: "Descubre cómo obtenerla",
      text: "Si eliges Qapex para probar tu software, al final del ciclo emitimos la <b>Certificación Qapex Quality Assured</b>: un certificado interno que documenta cobertura, resultados y calidad del lanzamiento, para compartir con clientes, partners y stakeholders.",
      certTitle: "CERTIFICADO DE CALIDAD",
      project: "Proyecto: Nombre de la aplicación · release 2.4",
      kpis: ["Pruebas ejecutadas", "Cobertura", "Bugs críticos"],
      date: "12/10/2026",
      dateLabel: "Fecha de emisión",
    },
  },

  // Pagina /certificazione-qapex (titolo, testo ed esempio di certificato sono in qa.cert)
  certPage: {
    howEyebrow: "Cómo se obtiene",
    howTitle: "Cuatro pasos, de los requisitos al certificado.",
    howLead: "El certificado es el resultado de un ciclo de pruebas completo, ejecutado por nuestro equipo certificado ISTQB.",
    steps: [
      { title: "Análisis de requisitos y Testbook AI", text: "Analizamos los requisitos de tu software y, con nuestra IA propia, preparamos un testbook a medida: los casos de prueba que hay que ejecutar." },
      { title: "Ejecución de los ciclos de prueba", text: "Ejecutamos ciclos de pruebas funcionales, de sistema y de integración, con las regresiones trazadas en cada lanzamiento." },
      { title: "Informe de calidad y trazabilidad", text: "Reunimos resultados, cobertura y defectos en un informe de calidad, con la trazabilidad entre requisitos y pruebas." },
      { title: "Emisión del certificado", text: "Al final del ciclo emitimos la Certificación Qapex Quality Assured, lista para compartir con clientes, partners y stakeholders." },
    ],
    ctaTitle: "¿Quieres certificar tu próximo lanzamiento?",
    ctaText: "Cuéntanos tu proyecto y te proponemos el ciclo de pruebas más adecuado. La primera consulta es gratuita.",
    cta: "Solicita un ciclo de pruebas",
  },

  process: {
    eyebrow: "Cómo trabajamos",
    title: "De la idea al lanzamiento, con la QA en cada sprint.",
    lead: "Ciclos cortos, validación continua y calidad integrada. Roadmap técnico y plan de QA se mantienen sincronizados: uno define qué se construye, el otro cómo se verifica.",
    steps: [
      { phase: "KICKOFF", title: "Objetivos claros", text: "Definición de objetivos y criterios de éxito, y alineación sobre stack tecnológico y limitaciones." },
      { phase: "SPRINTS CÍCLICOS", title: "Desarrollo verificado", text: "Desarrollo con revisiones técnicas y checkpoints de QA en cada sprint, no solo al final." },
      { phase: "GO-LIVE", title: "Lanzamiento seguro", text: "Checklist de calidad, plan de monitorización y roadmap de mejora continua." },
    ],
  },

  products: {
    eyebrow: "Nuestros productos",
    title: "Herramientas de IA propias.",
    demo: "Solicita una demo",
    quack: {
      text: "Sube audio, vídeo, notas o fotos de pizarras: obtén análisis funcional, backlog y change requests listos en .docx y .pdf.",
      cta: "Descubre QUACK",
      play: "Ver el vídeo de presentación de QUACK",
      tools: "Herramientas",
      steps: ["Reunión", "Backlog", "Change Request"],
      running: "Análisis en curso…",
    },
    subq: {
      text: "Work in progress",
      cta: "Descubre SubQ",
    },
  },

  certs: {
    eyebrow: "Certificaciones",
    title: "Estándares internacionales, verificables.",
    lead: "Nuestro equipo está certificado según los estándares de referencia para la calidad del software.",
    active: "✓ ACTIVA · 2026",
    planned: "PLANIFICADA · 2026–2028",
    istqb: "International Software Testing Qualifications Board, reconocido en más de 120 países.",
    iso9001: "Sistema de gestión de la calidad de los procesos empresariales.",
    iso27001: "Seguridad de la información y protección de datos.",
  },

  refs: {
    eyebrow: "Referencias",
    title: "Lo que dicen de nosotros.",
    carousel: "carrusel",
    goTo: "Reseña {n}",
    items: {
      stefanetti: {
        role: "Fundador, Symposium Group",
        text: "Elegimos Qapex para desarrollar la aplicación de nuestra comunidad y quedamos muy contentos: un equipo joven con ganas de hacer, atento a la calidad, a los detalles y, sobre todo, a la rapidez. Os los recomiendo de todo corazón.",
      },
      pettini: {
        role: "CTO, Engineer, Teacher",
        text: "Nima y su equipo se encargaron de todos los aspectos del testing de todo el servicio ParkingMyCar, introdujeron metodologías de prueba y desarrollaron un framework de test automation, garantizando la calidad en cada uno de nuestros lanzamientos. Fue una excelente inversión.",
      },
      innamorati: {
        role: "Connecting the finest SAP Professionals worldwide",
        text: "Qapex tiene consultores con los que todo el mundo querría trabajar. Son muy competentes, además de totalmente comprometidos y humildes. Han resuelto con rapidez muchos problemas relacionados con la fase de pruebas de varios proyectos.",
      },
      picciotto: {
        role: "QA Specialist, Competence Center & Offering Management",
        text: "Siempre disponibles y dispuestos a implicarse. Si hay un proyecto que sacar adelante, sé que puedo contar con Nima y su equipo para entregarlo con calidad.",
      },
      lombardozzi: {
        role: "Program Manager",
        text: "Un profesional con gran capacidad de resolución de problemas, excelentes soft skills y una comunicación sobresaliente. Sus ideas siempre han sido estimulantes y han aumentado la calidad y la eficiencia de los proyectos.",
      },
    },
  },

  contact: {
    eyebrow: "Contacto",
    title: "¿Listo para transformar tu negocio?",
    lead: "Hablemos. Nuestro equipo está a tu disposición para construir contigo soluciones digitales a medida. La primera consulta es gratuita.",
    email: "Email",
    office: "Sede",
    officeValue: "Via della Louvière 1/A, 06034 Foligno (PG), Italia",
    vat: "NIF-IVA",
    formTitle: "Escríbenos",
    firstName: "Nombre",
    firstNamePlaceholder: "Juan",
    lastName: "Apellido",
    lastNamePlaceholder: "García",
    emailPlaceholder: "juan@empresa.com",
    phone: "Número de teléfono",
    phonePrefix: "Prefijo",
    phonePlaceholder: "612 345 678",
    service: "Servicio de interés",
    selectService: "Selecciona una opción",
    message: "Mensaje",
    messagePlaceholder: "¿Cómo podemos ayudarte?",
  },

  footer: {
    tagline: "Construimos software con la velocidad de la IA y el rigor de la QA. Desde Foligno, en el corazón verde de Umbría.",
    navigate: "NAVEGA",
    company: "EMPRESA",
    legal: "LEGAL",
    contacts: "Contacto",
    privacy: "Política de privacidad",
    cookies: "Política de cookies",
    legalNotes: "Aviso legal",
    rights: "QAPEX S.r.l. · NIF-IVA IT03818350542 · All rights reserved.",
  },

  video: {
    dialog: "Vídeo",
    close: "Cerrar vídeo",
  },
};

export default home;
